import React, { Component } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import Utilities from '../../global/Utilities';

// const locations = 
const mapStyles = {
    height: "50vh",
    width: "100%"
};

class MapContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: {},
            isUpdate: false,
            locations: [],
            defaultCenter: {
                lat: 22.98596571991664, lng: 72.43479279500757
            }

        }
    }

    componentDidUpdate(prevState, prevProps) {
        if (!this.isEdit) {
            if (prevProps?.locations !== this.props?.locations) {
                if (!this.state.isUpdate) {
                    const { locations } = this.props;
                    Utilities.LogPrint("$$locations0", locations);
                    if (locations != null && locations?.length > 0) {
                        Utilities.LogPrint("$$locations1", locations);
                        // this.setState({ images: imagePaths.map(({ image_url: path, krishak_image_id: id, ...rest }) => ({ path, id, ...rest })), isUpdate: true, addImageVisible: (imagePaths.length < 3) });
                        this.setState({ locations, isUpdate: true, defaultCenter: locations[0].location });
                    }
                }
            }
        }
    }

    onSelect = item => {
        this.setState({ selected: item })
    }

    getMakerImages(id) {
        switch (id) {
            case 1:
                return "http://maps.google.com/mapfiles/ms/icons/blue.png"
            case 2:
                return "http://maps.google.com/mapfiles/ms/micons/green.png"
            case 3:
                return "http://maps.google.com/mapfiles/ms/micons/red.png"
            case 4:
                return "http://maps.google.com/mapfiles/ms/micons/purple.png"

            default:
                break;
        }
    }

    render() {
        const { locations, selected, defaultCenter } = this.state;
        return (
            <LoadScript
                googleMapsApiKey='AIzaSyBuXUsruJF5kvGVYyPfRL5i_yPP5u7r4Os'>
                {/* <GoogleMap
                    mapContainerStyle={mapStyles}
                    zoom={13}
                    center={defaultCenter}
                /> */}
                <GoogleMap
                    mapContainerStyle={mapStyles}
                    zoom={13}
                    center={defaultCenter}>
                    {
                        locations.map((item, index) => {
                            return (
                                <Marker
                                    icon={this.getMakerImages(item.id)}
                                    key={index}
                                    position={item.location}
                                    onClick={() => this.onSelect(item)} />
                            )
                        })
                    }
                    {
                        selected.location &&
                        (
                            <InfoWindow
                                position={selected.location}
                                clickable={true}
                            // onCloseClick={() => setSelected({})}
                            >
                                <p>{selected.name}</p>
                            </InfoWindow>
                        )
                    }
                </GoogleMap>
            </LoadScript>
        )
    }
}


export default MapContainer